module.exports = __webpack_public_path__ + "static/image/logo-family/logo_takeout.png?32105a36";